import _ from 'lodash';
import moment from 'moment-timezone'

const canEditInvoice = (state) => (can) => {
  if(state.selectedInvoice!=null && state.selectedInvoice.status!=null){
    return ((can('write','Invoices') || can('manage', 'Invoices')));
  }
  return false;
}

function getInvoiceStatusType(invoice){
  let tagType = '';//Default tagType => SENT
  if(invoice!=null && invoice.status!=null){
    if(invoice.status.code==="DRAFT"){
      tagType = "info";
    }else if(invoice.status.code==="PAID"){
      tagType = "success";
    }else if(invoice.status.code==="VOIDED"){
      tagType = "danger";
    }
  }
  return tagType;
}

const selectedInvoiceTagType = (state) =>{
  return getInvoiceStatusType(state.selectedInvoice);
}

const getInvoiceTagType = (state) => (status) =>{
  return getInvoiceStatusType({status});
}

const getOrderBy = (state) =>{
  return state.orderBy;
}

const getSortIcon = (state) =>{
  return state.sort_icon;
}

const canMarkAsSent = (state) =>{
  return state.selectedInvoice.sent_at==null

}

const canAddPayment = (state)=>{
  if(state.selectedInvoice==null || state.selectedInvoice.status==null) return false;
  return !(state.selectedInvoice.status.code=="VOIDED" ||
         state.selectedInvoice.status.code=="PAID")
}

const canVoidInvoice = (state)=> (can)=>{
  if(state.selectedInvoice==null ||  state.selectedInvoice.status==null) return false;
  return state.selectedInvoice.status.code!=="VOIDED" && can('manage','Invoice');
}

function calculatePaymentsAmount(payments){
  let paymentsAmount = 0.00;
  _.forEach(payments, payment=>{
    paymentsAmount+=payment.invoice_payment.amount;
  })
  return paymentsAmount
}

function calculateCreditNotesAmount(creditNotes){
  let creditNotesAmount = 0.00;
  _.forEach(creditNotes, credit=>{
    creditNotesAmount+=credit.amountApplied;
  })
  return creditNotesAmount
}

const amountPaid = (state) => {
  if(state.selectedInvoice==null)return null;
  else{
    return calculatePaymentsAmount(state.selectedInvoice.payments);
  }
}


const amountDue = (state) =>{
  if(state.selectedInvoice==null) return null;
  else{
    let creditNoteAmount = calculateCreditNotesAmount(state.selectedInvoice.creditNotes);
    let paymentsAmount = calculatePaymentsAmount(state.selectedInvoice.payments)
    return state.selectedInvoice.total-creditNoteAmount-paymentsAmount;
  }
}

const attachedFiles = (state) =>{
  let filelist = [];
  if(state.selectedInvoice!=null){
    _.forEach(state.selectedInvoice.files, file=>{
      filelist.push({
        id : file.id,
        invoiceId : state.selectedInvoice.id,
        name : file.filename,
      })
    })
  }
  return filelist;
}

const customerName = (state) => (customer, forceRealName=false) =>{
  if(customer!=null && customer.usual_name!=null && customer.usual_name!='' && !forceRealName){
    return customer.usual_name;
  }else if(customer!=null){
    return customer.name;
  }else{
    return null;
  }
}

const getCreditItemLineTotal = (state) =>{
  let credit = 0;
  _.forEach(state.selectedInvoice.lines, item=>{
    if(item.credit!=null){
      credit+=item.credit;
    }
  })
  return credit;
}


const getCreditNotes = (state) => {
  if(state.selectedInvoice.creditNotes!=null && state.selectedInvoice.creditNotes.length>0){
    return state.selectedInvoice.creditNotes;
  }else{
    return null;
  }
}

const canShowCreditsLeft = (state) =>{
  return( state.selectedInvoice != null &&
      (state.selectedInvoice.balance!=null && state.selectedInvoice.balance.outstanding>0) &&
      (state.selectedInvoice.customer!=null && state.selectedInvoice.customer.balance.credit>0) &&
      (state.selectedInvoice.status!=null && state.selectedInvoice.status.code!='PAID'))
}

const returnSignIfNotSent = (state) =>{
  if(state.selectedInvoice.sentAt == null && state.selectedInvoice.status && state.selectedInvoice.status.code!='PAID' && state.selectedInvoice.status.code!='VOIDED'){
    return '!';
  }else{
    return '';
  }
}

const getNbFiltersCriteria = (state) => {
  let nb = 0;
  if(state.filters.status.length>0)nb++;
  if(state.filters.date != null)nb++;
  if(state.filters.paidAt != null)nb++;
  if(state.filters.checkedCustomerClasses.length>0)nb++;
  if(state.filters.checkedInvoiced.length>0)nb++;
  if(state.filters.checkedReps.length>0)nb++;
  if(state.filters.withoutReps==true)nb++;
  if(state.filters.customerId != null)nb++;
  if(state.filters.productId != null)nb++;
  return nb;
}

const isFiltered = (state) =>{
  return !(state.filters.status.length == 0 &&
          state.filters.date==null &&
          state.filters.paidAt==null &&
          state.filters.checkedCustomerClasses.length==0 &&
          state.filters.checkedInvoiced.length==0 &&
          state.filters.checkedReps.length==0 &&
          state.filters.withoutReps==false &&
          state.filters.customerId == null &&
          state.filters.productId == null &&
          state.searchTerms==''
        )
}


export default {
  getCreditNotes,
  getOrderBy,
  getSortIcon,
  selectedInvoiceTagType,
  canEditInvoice,
  getInvoiceTagType,
  canMarkAsSent,
  canAddPayment,
  canVoidInvoice,
  amountDue,
  amountPaid,
  attachedFiles,
  customerName,
  getCreditItemLineTotal,
  canShowCreditsLeft,
  returnSignIfNotSent,
  isFiltered,
  getNbFiltersCriteria
};
